





import {apiV1AdminNewJobPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import Post, {IPost} from '@/models/Post'
import {BreadCrumb} from '@/pages/page-base'
import NewJob from "@/models/NewJob"

@Component({
  components: {
    PostForm
  }
})
export default class NewJobsEdit extends PostEdit {
  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminNewJobPath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new NewJob(data)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '新着求人',
        to: '/admin/new_jobs',
        exact: true
      },
      {
        text: '新着求人編集'
      }
    ]
  }
}
